"use client";
import Button from "@/components/UI/Button/Button";
import { useCartContext } from "@/providers/CartContextProvider";

import useRegionAndLocale from "@/hooks/useRegionAndLocale";
import { useMemo } from "react";
import { translatePath } from "@/i18n/paths/path-translator";

interface Props {
	className?: string;
	children?: React.ReactNode;
}

export const CheckoutButton = ({ className, children }: Props) => {
	const { region, lang, locale } = useRegionAndLocale();
	const { cart } = useCartContext();

	const checkoutUrl = useMemo(() => {
		return translatePath({
			path: "/checkout",
			locale,
			prefix: `/${region}/${lang}`,
		});
	}, [region, lang, locale]);

	if (!cart) {
		return null;
	}

	return (
		<Button className={className} as='link' href={checkoutUrl}>
			{children}
		</Button>
	);
};
